import { render, staticRenderFns } from "./xlcsChart.vue?vue&type=template&id=20d505e1"
import script from "./xlcsChart.vue?vue&type=script&lang=js"
export * from "./xlcsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports